<template>
  <div class="a-accordion__collapse u-padding-left-0">
    <div class="a-accordion__tab">
      <div class="a-accordion__block" v-for="item in records">
        <!-- criteria name and control buttons -->
        <div class="a-accordion__block-content" v-if="item.editable">
          <div class="select-w-755">
            <div class="a-form-field a-width-100-percent">
              <input type="text" class="a-input a-width-100-percent" v-model="item.name" @keyup.enter="onConfirmClick(item)">
              <span class="a-helper-text a-validation-error" v-if="item.error">{{$t('labels.mandatory-field')}}</span>
            </div>
          </div>
          <div class="a-accordion__btn-tab a-accordion__btn-tab--justify-end a-width-auto u-margin-left-50">
            <button class="a-accordion__ok-btn" @click.prevent="onConfirmClick(item)">
              <img src="@/assets/img/static/tab-ok.svg" alt="">
            </button>
            <button class="a-accordion__clear-btn" @click.prevent="onCancelClick(item)">
              <img src="@/assets/img/static/tab-close.svg" alt="">
            </button>
          </div>
        </div>
        <div class="a-accordion__block-content " v-else>
          <div class="a-accordion__block-title">{{item.name}}</div>
          <div class="a-accordion__btn-tab a-accordion__btn-tab--justify-end a-width-300">
            <button class="a-accordion__editing-btn" @click.prevent="$emit('editItem', item)">
              <img src="@/assets/img/static/b-icon_edit.svg" alt="">
              {{$t('buttons.modify')}}
            </button>
            <button class="a-accordion__remove-btn" @click.prevent="$emit('deleteItem', item)" v-if="item.type !== 'ReducedPrice'">
              <img src="@/assets/img/static/trashcan.svg" alt="">
            </button>
          </div>
        </div>
        <div class="a-accordion__block-content" v-if="item.type !== 'ReducedPrice'">
          <div class="a-container-form u-padding-bottom-0 a-width-100-percent">
            <div class="a-label a-label--w-280">{{$t('form.catalogs.catalog-type.price-criteria.criteria-format')}}:</div>
            <div class="a-flex-start a-width-100-percent">
              <div class="a-checkbox a-checkbox--inline-flex">
                <label class="a-checkbox__label u-margin-b-0" :class="{ 'a-checkbox__label--disable': !item.editable }">
                  <input class="a-checkbox__input" type="checkbox" v-model="item.isText">
                  <span class="a-checkbox__icon"></span>
                  <span class="a-checkbox__text">{{$t('form.catalogs.catalog-type.price-criteria.format.text')}}</span>
                </label>
                <label class="a-checkbox__label u-margin-b-0 u-margin-left-20" :class="{ 'a-checkbox__label--disable': !item.editable }">
                  <input class="a-checkbox__input" type="checkbox" v-model="item.isFile">
                  <span class="a-checkbox__icon"></span>
                  <span class="a-checkbox__text">{{$t('form.catalogs.catalog-type.price-criteria.format.document')}}</span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { required } from '@/validators'

  export default {
    props: {
      documents: Array,
      isNew: Boolean
    },

    computed: {
      records() {
        return this.documents;
      }
    },

    methods: {
      onConfirmClick(item) {
        if (!required(item.name)) {
          this.$set(item, 'error', true);
          return;
        }

        this.$set(item, 'error', false);
        this.$emit('confirmEditable', item);
      },

      onCancelClick(item) {
        this.$emit('cancelEditable', item);
      }
    }
  }
</script>

<style scoped>

</style>
